export default {
      id: "wheelchair-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "sprite.svg#wheelchair",
      toString: function () {
        return this.url;
      }
    }